<h1 mat-dialog-title class="se-dialog-header-warning">{{ data.message }}</h1>
<div mat-dialog-content style="width: 100%">
    <div [formGroup]="form">
        <mat-form-field *ngIf="data.isDeletingReasonEnabled">
            <mat-label>{{ "DeletingReason" | translate }}</mat-label>
            <mat-select formControlName="deletingReason">
                @for (item of data.deletingReasonItems; track item) {
                    <mat-option [value]="item.guid">{{ item.description }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</div>
<mat-dialog-actions class="dialog-actions">
    <button (click)="closeDialog()" color="primary" mat-button mat-dialog-close>
        {{ cancelLabel | translate }}
    </button>
    <button (click)="confirm()" color="primary" mat-button>{{ confirmLabel | translate }}</button>
</mat-dialog-actions>
